module.exports = __webpack_public_path__ + "images/acc5a95c7aeb8017d3ad6f12ee0732d4-IMG_5817.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living2/IMG_5817.jpg
// module id = ./src/assets/images/slides/living2/IMG_5817.jpg
// module chunks = 0